import moment from 'moment-timezone';

/**
 * Return a moment instance with the config
 * @param {string} expression timeDelta expression
 *
 * @return moment instance
 */
// function time(expression: string) {
//   const m = moment();
//   const agoRegex = new RegExp('[ago|AGO]', 'g');
//   const yearsRegex = new RegExp('(\\d*)[y|Y]', 'g');
//   const yearMatches = yearsRegex.exec(expression);

//   const ago = agoRegex.test(expression);
//   console.log('---------ago: ', ago, ', yM: ', yearMatches);

//   if (yearMatches) {
//     if (ago) {
//       m.subtract(+yearMatches[1], 'years');
//     } else {
//       m.add(+yearMatches[1], 'years');
//     }
//   }

//   return m;
// }

function time(expression: string) {
  let resultDate = moment();

  const parts = expression.split(' ');
  const agoRegex = /\b(ago|AGO)\b/g;
  const isAgo = agoRegex.test(expression);

  for (let i = 0; i < parts.length; i += 2) {
    if (parts[i] === 'ago') {
      break;
    }
    const value = parseInt(parts[i], 10);
    let unit = parts[i + 1];

    if (isNaN(value)) {
      // throw new Error('Invalid input format');
      // We should handle the format error here
      return undefined;
    }

    let momentUnit: moment.unitOfTime.DurationConstructor | undefined;
    if (unit === 'y' || unit === 'year' || unit === 'years') {
      momentUnit = 'year';
    } else if (unit === 'M' || unit === 'month' || unit === 'months') {
      momentUnit = 'month';
    } else if (unit === 'w' || unit === 'week' || unit === 'weeks') {
      momentUnit = 'week';
    } else if (unit === 'd' || unit === 'day' || unit === 'days') {
      momentUnit = 'day';
    } else if (unit === 'h' || unit === 'hour' || unit === 'hours') {
      momentUnit = 'hour';
    } else if (unit === 'm' || unit === 'minute' || unit === 'minutes') {
      momentUnit = 'minute';
    } else if (unit === 's' || unit === 'second' || unit === 'seconds') {
      momentUnit = 'second';
    }

    if (momentUnit) {
      if (isAgo) {
        resultDate = resultDate.subtract(value, momentUnit);
      } else {
        resultDate = resultDate.add(value, momentUnit);
      }
    }

    console.log('------v: ', value, ', u: ', unit, ', isAgo: ', isAgo);
  }

  return resultDate;
}

export default time;
